import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  getNeighborhoods,
  getNeighborhoodsObj,
  getPropertiesTypes
} from 'redux/propsSlice';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);

    dispatch(getPropertiesTypes());
    dispatch(getNeighborhoods());
    dispatch(getNeighborhoodsObj());
  }, []);

  return (
    <Container
      className="m-0 p-0 w-100"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minWidth: '100%'
      }}
      fluid={true}
    >
      <Container className="m-0 w-100 mw-100">
        <NavbarVertical />
        <div
          className="content pb-0"
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: 'fit',
            justifyContent: 'space-between'
          }}
        >
          <div
            className="position-relative pb-3"
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: 'fit'
            }}
          >
            <NavbarTop />

            <Outlet />
          </div>
          <p className="mb-3 text-end">
            Portal Inmobiliario del Colegio Inmobiliario | 2023 v0.2.0 ©{' '}
            <a
              href="http://colegioinmobiliario.org.ar/"
              rel="noreferrer"
              target="_blank"
            >
              CUCICBA
            </a>
          </p>
        </div>
      </Container>
    </Container>
  );
};

MainLayout.propTypes = {
  socket: PropTypes.object
};

export default MainLayout;
